import { quickAddActionCreators } from '@app/components/QuickAddModal/modules/quickAdd'
import { ApplicationState } from '@app/store'
import {
  actionCreators,
  IGlobalCompanyContactsState,
  IGlobalHbUserState,
  selectCompanyContacts,
  selectHbContacts,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { AssociatedContactsSelector } from '../components/AssociatedContactsSelector'

export default connect(
  createStructuredSelector<
    ApplicationState,
    IGlobalCompanyContactsState & IGlobalHbUserState
  >({
    companyContacts: selectCompanyContacts(),
    hbContacts: selectHbContacts(),
  }),
  { ...actionCreators, ...quickAddActionCreators },
)(AssociatedContactsSelector)
